import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IconCircleComponent } from '../icon-circle/icon-circle.component';

@Component({
    selector: 'app-page-empty-search-result',
    templateUrl: './page-empty-search-result.component.html',
    styleUrl: './page-empty-search-result.component.scss',
    standalone: true,
    imports: [
        MatIconModule, CommonModule,
        IconCircleComponent
    ]
})
export class PageEmptySearchResultComponent {

    @Input() big: boolean = false
    @Input() minHeight: number = 500
    @Input() iconName: string | null = null
    @Input() title: string | null = null
    @Input() description: string | null = null
    @Input() actionTitle: string | null = null
    @Input() actionIsSelect: boolean = false
    @Input() image: string | undefined = undefined

    @Output() action: EventEmitter<boolean> = new EventEmitter()

}
